import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";

export const FONT_THEME = {
  "@font-face": [
    {
      fontFamily: "Cocon",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Cocon Light.otf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 300,
      fontStyle: "normal",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-Thin.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 100,
      fontStyle: "normal",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-ThinItalic.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 100,
      fontStyle: "italic",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-Light.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 300,
      fontStyle: "normal",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-LightItalic.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 300,
      fontStyle: "italic",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-Regular.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 400,
      fontStyle: "normal",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-RegularItalic.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 400,
      fontStyle: "italic",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-Medium.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 500,
      fontStyle: "normal",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-MediumItalic.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 500,
      fontStyle: "italic",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-Bold.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 700,
      fontStyle: "normal",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-BoldItalic.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 700,
      fontStyle: "italic",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-Black.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 900,
      fontStyle: "normal",
    },
    {
      fontFamily: "Roboto",
      src: `url('${generateFrontPath({
        id: "@front.internal-assets",
        parameters: {
          filePath: "fonts/Roboto-BlackItalic.ttf",
        },
        includeBasePath: true,
      })}') format('truetype')`,
      fontWeight: 900,
      fontStyle: "italic",
    },
  ],
};
